import { render, staticRenderFns } from "./histogram3.vue?vue&type=template&id=27b1f671&scoped=true&"
import script from "./histogram3.vue?vue&type=script&lang=js&"
export * from "./histogram3.vue?vue&type=script&lang=js&"
import style0 from "./histogram3.vue?vue&type=style&index=0&id=27b1f671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1f671",
  null
  
)

export default component.exports